// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/vehicle_identity.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { ContractVehicle } from "./delivery_pb";
/**
 * Tenant and actor are derived from the authenticated gateway principal.
 * IDs are caller-generated UUIDs. Reusing an ID cannot insert a second record.
 * Updates replace the editable value and require its current revision.
 *
 * @generated from message mono.datagateway.v1.VehicleProfile
 */ export class VehicleProfile extends Message {
    static fromBinary(bytes, options) {
        return new VehicleProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleProfile, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractVehicle vehicle = 1;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: repeated string aliases = 2;
   */ _define_property(this, "aliases", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleProfile, "runtime", proto3);
_define_property(VehicleProfile, "typeName", "mono.datagateway.v1.VehicleProfile");
_define_property(VehicleProfile, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle",
            kind: "message",
            T: ContractVehicle
        },
        {
            no: 2,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BrowseVehiclesRequest
 */ export class BrowseVehiclesRequest extends Message {
    static fromBinary(bytes, options) {
        return new BrowseVehiclesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowseVehiclesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowseVehiclesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowseVehiclesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * name/established alias prefix, never a fuzzy merge
   *
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * @generated from field: string agency_id = 2;
   */ _define_property(this, "agencyId", ""), /**
   * @generated from field: string vehicle_type = 3;
   */ _define_property(this, "vehicleType", ""), /**
   * false for ordinary selectors
   *
   * @generated from field: bool include_inactive = 4;
   */ _define_property(this, "includeInactive", false), /**
   * @generated from field: string after_id = 5;
   */ _define_property(this, "afterId", ""), /**
   * default 50, maximum 100
   *
   * @generated from field: int32 limit = 6;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BrowseVehiclesRequest, "runtime", proto3);
_define_property(BrowseVehiclesRequest, "typeName", "mono.datagateway.v1.BrowseVehiclesRequest");
_define_property(BrowseVehiclesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "agency_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_inactive",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BrowseVehiclesResponse
 */ export class BrowseVehiclesResponse extends Message {
    static fromBinary(bytes, options) {
        return new BrowseVehiclesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowseVehiclesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowseVehiclesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowseVehiclesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractVehicle vehicles = 1;
   */ _define_property(this, "vehicles", []), /**
   * @generated from field: string next_after_id = 2;
   */ _define_property(this, "nextAfterId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BrowseVehiclesResponse, "runtime", proto3);
_define_property(BrowseVehiclesResponse, "typeName", "mono.datagateway.v1.BrowseVehiclesResponse");
_define_property(BrowseVehiclesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicles",
            kind: "message",
            T: ContractVehicle,
            repeated: true
        },
        {
            no: 2,
            name: "next_after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetVehicleProfileRequest
 */ export class GetVehicleProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetVehicleProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVehicleProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVehicleProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVehicleProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVehicleProfileRequest, "runtime", proto3);
_define_property(GetVehicleProfileRequest, "typeName", "mono.datagateway.v1.GetVehicleProfileRequest");
_define_property(GetVehicleProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetVehicleProfileResponse
 */ export class GetVehicleProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetVehicleProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetVehicleProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetVehicleProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetVehicleProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.VehicleProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetVehicleProfileResponse, "runtime", proto3);
_define_property(GetVehicleProfileResponse, "typeName", "mono.datagateway.v1.GetVehicleProfileResponse");
_define_property(GetVehicleProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: VehicleProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveVehicleProfileRequest
 */ export class SaveVehicleProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveVehicleProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveVehicleProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveVehicleProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveVehicleProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.VehicleProfile profile = 1;
   */ _define_property(this, "profile", void 0), /**
   * zero creates; stale updates are aborted
   *
   * @generated from field: int64 expected_revision = 2;
   */ _define_property(this, "expectedRevision", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveVehicleProfileRequest, "runtime", proto3);
_define_property(SaveVehicleProfileRequest, "typeName", "mono.datagateway.v1.SaveVehicleProfileRequest");
_define_property(SaveVehicleProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: VehicleProfile
        },
        {
            no: 2,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveVehicleProfileResponse
 */ export class SaveVehicleProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveVehicleProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveVehicleProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveVehicleProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveVehicleProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.VehicleProfile profile = 1;
   */ _define_property(this, "profile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveVehicleProfileResponse, "runtime", proto3);
_define_property(SaveVehicleProfileResponse, "typeName", "mono.datagateway.v1.SaveVehicleProfileResponse");
_define_property(SaveVehicleProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "profile",
            kind: "message",
            T: VehicleProfile
        }
    ]));
/**
 * A recorded relationship is separate from source association and eligibility.
 * Empty scope means unknown, NEVER all scopes. Absent dates stay unknown.
 *
 * @generated from message mono.datagateway.v1.VehicleRelationship
 */ export class VehicleRelationship extends Message {
    static fromBinary(bytes, options) {
        return new VehicleRelationship().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleRelationship().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleRelationship().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleRelationship, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string vehicle_id = 2;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string company_id = 3;
   */ _define_property(this, "companyId", ""), /**
   * direct_holder, jv_participant, other
   *
   * @generated from field: string relationship_type = 4;
   */ _define_property(this, "relationshipType", ""), /**
   * actual legal holder/intermediary
   *
   * @generated from field: string holder_company_id = 5;
   */ _define_property(this, "holderCompanyId", ""), /**
   * SAD-984 contextual holder_contract
   *
   * @generated from field: string holder_registry_contract_id = 6;
   */ _define_property(this, "holderRegistryContractId", ""), /**
   * source-faithful text, may be unresolved
   *
   * @generated from field: string holder_contract_number = 7;
   */ _define_property(this, "holderContractNumber", ""), /**
   * @generated from field: string scope = 8;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: google.protobuf.Timestamp holding_start = 9;
   */ _define_property(this, "holdingStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp holding_end = 10;
   */ _define_property(this, "holdingEnd", void 0), /**
   * @generated from field: string source_basis = 11;
   */ _define_property(this, "sourceBasis", ""), /**
   * @generated from field: string source_artifact_id = 12;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * UNVERIFIED or VERIFIED
   *
   * @generated from field: string verification_status = 13;
   */ _define_property(this, "verificationStatus", ""), /**
   * precisely what is supported; no eligibility claim
   *
   * @generated from field: string verified_fact = 14;
   */ _define_property(this, "verifiedFact", ""), /**
   * @generated from field: google.protobuf.Timestamp verification_start = 15;
   */ _define_property(this, "verificationStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp verification_end = 16;
   */ _define_property(this, "verificationEnd", void 0), /**
   * @generated from field: string notes = 17;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: int64 revision = 18;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * @generated from field: google.protobuf.Timestamp archived_at = 19;
   */ _define_property(this, "archivedAt", void 0), /**
   * @generated from field: string recorded_by = 20;
   */ _define_property(this, "recordedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleRelationship, "runtime", proto3);
_define_property(VehicleRelationship, "typeName", "mono.datagateway.v1.VehicleRelationship");
_define_property(VehicleRelationship, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relationship_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "holder_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "holder_registry_contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "holder_contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "holding_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "holding_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "source_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "verification_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "verified_fact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "verification_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "verification_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 19,
            name: "archived_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleRelationshipsRequest
 */ export class ListVehicleRelationshipsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleRelationshipsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleRelationshipsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleRelationshipsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleRelationshipsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * at least one of vehicle/company required
   *
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string company_id = 2;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: bool include_history = 3;
   */ _define_property(this, "includeHistory", false), /**
   * @generated from field: string after_id = 4;
   */ _define_property(this, "afterId", ""), /**
   * @generated from field: int32 limit = 5;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleRelationshipsRequest, "runtime", proto3);
_define_property(ListVehicleRelationshipsRequest, "typeName", "mono.datagateway.v1.ListVehicleRelationshipsRequest");
_define_property(ListVehicleRelationshipsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_history",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleRelationshipsResponse
 */ export class ListVehicleRelationshipsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleRelationshipsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleRelationshipsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleRelationshipsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleRelationshipsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleRelationship relationships = 1;
   */ _define_property(this, "relationships", []), /**
   * @generated from field: string next_after_id = 2;
   */ _define_property(this, "nextAfterId", ""), /**
   * present only for an exhausted first visible page
   *
   * @generated from field: optional int64 total = 3;
   */ _define_property(this, "total", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleRelationshipsResponse, "runtime", proto3);
_define_property(ListVehicleRelationshipsResponse, "typeName", "mono.datagateway.v1.ListVehicleRelationshipsResponse");
_define_property(ListVehicleRelationshipsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationships",
            kind: "message",
            T: VehicleRelationship,
            repeated: true
        },
        {
            no: 2,
            name: "next_after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveVehicleRelationshipRequest
 */ export class SaveVehicleRelationshipRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveVehicleRelationshipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveVehicleRelationshipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveVehicleRelationshipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveVehicleRelationshipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.VehicleRelationship relationship = 1;
   */ _define_property(this, "relationship", void 0), /**
   * @generated from field: int64 expected_revision = 2;
   */ _define_property(this, "expectedRevision", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveVehicleRelationshipRequest, "runtime", proto3);
_define_property(SaveVehicleRelationshipRequest, "typeName", "mono.datagateway.v1.SaveVehicleRelationshipRequest");
_define_property(SaveVehicleRelationshipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship",
            kind: "message",
            T: VehicleRelationship
        },
        {
            no: 2,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveVehicleRelationshipResponse
 */ export class SaveVehicleRelationshipResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveVehicleRelationshipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveVehicleRelationshipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveVehicleRelationshipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveVehicleRelationshipResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.VehicleRelationship relationship = 1;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveVehicleRelationshipResponse, "runtime", proto3);
_define_property(SaveVehicleRelationshipResponse, "typeName", "mono.datagateway.v1.SaveVehicleRelationshipResponse");
_define_property(SaveVehicleRelationshipResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship",
            kind: "message",
            T: VehicleRelationship
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ArchiveVehicleRelationshipRequest
 */ export class ArchiveVehicleRelationshipRequest extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveVehicleRelationshipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveVehicleRelationshipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveVehicleRelationshipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveVehicleRelationshipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int64 expected_revision = 2;
   */ _define_property(this, "expectedRevision", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveVehicleRelationshipRequest, "runtime", proto3);
_define_property(ArchiveVehicleRelationshipRequest, "typeName", "mono.datagateway.v1.ArchiveVehicleRelationshipRequest");
_define_property(ArchiveVehicleRelationshipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ArchiveVehicleRelationshipResponse
 */ export class ArchiveVehicleRelationshipResponse extends Message {
    static fromBinary(bytes, options) {
        return new ArchiveVehicleRelationshipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArchiveVehicleRelationshipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArchiveVehicleRelationshipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArchiveVehicleRelationshipResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArchiveVehicleRelationshipResponse, "runtime", proto3);
_define_property(ArchiveVehicleRelationshipResponse, "typeName", "mono.datagateway.v1.ArchiveVehicleRelationshipResponse");
_define_property(ArchiveVehicleRelationshipResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleConnectionsRequest
 */ export class ListVehicleConnectionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleConnectionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleConnectionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleConnectionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleConnectionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vehicle_id = 1;
   */ _define_property(this, "vehicleId", ""), /**
   * labor, rate, source, program, association
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string after_id = 3;
   */ _define_property(this, "afterId", ""), /**
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleConnectionsRequest, "runtime", proto3);
_define_property(ListVehicleConnectionsRequest, "typeName", "mono.datagateway.v1.ListVehicleConnectionsRequest");
_define_property(ListVehicleConnectionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.VehicleConnection
 */ export class VehicleConnection extends Message {
    static fromBinary(bytes, options) {
        return new VehicleConnection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleConnection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleConnection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleConnection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string artifact_id = 5;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string program_id = 6;
   */ _define_property(this, "programId", ""), /**
   * owning labor entry for a rate observation
   *
   * @generated from field: string lcat_entry_id = 7;
   */ _define_property(this, "lcatEntryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleConnection, "runtime", proto3);
_define_property(VehicleConnection, "typeName", "mono.datagateway.v1.VehicleConnection");
_define_property(VehicleConnection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListVehicleConnectionsResponse
 */ export class ListVehicleConnectionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListVehicleConnectionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListVehicleConnectionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListVehicleConnectionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListVehicleConnectionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleConnection connections = 1;
   */ _define_property(this, "connections", []), /**
   * @generated from field: string next_after_id = 2;
   */ _define_property(this, "nextAfterId", ""), /**
   * authorized visible total, never raw database count
   *
   * @generated from field: optional int64 total = 3;
   */ _define_property(this, "total", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListVehicleConnectionsResponse, "runtime", proto3);
_define_property(ListVehicleConnectionsResponse, "typeName", "mono.datagateway.v1.ListVehicleConnectionsResponse");
_define_property(ListVehicleConnectionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "connections",
            kind: "message",
            T: VehicleConnection,
            repeated: true
        },
        {
            no: 2,
            name: "next_after_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ ,
            opt: true
        }
    ]));
